import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import {
  findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum,
  useFindFaqByLanguage,
} from "~/gen/api"
import { i18n } from "~/i18n"
import { FAQAdmin } from "~/pages/Admin/FAQ/FAQAdmin"

export const FAQAdminWrapper = () => {
  const lang = i18n.language
    .split("-")[0]
    .toUpperCase() as keyof typeof findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum

  const faqQuery = useFindFaqByLanguage(
    findFaqByLanguageHttpControllerFindFaqByLanguagePathParamsLangEnum[lang]
  )

  return (
    <DataFetchWrapper query={faqQuery}>
      {({ data }) => <FAQAdmin faqs={data.data} />}
    </DataFetchWrapper>
  )
}
